import store from "@/redux/store";

import React, { useState } from "react";
import { useParams } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import { Overview } from "@/views/team/Overview";
import { loadUsers } from '@/reducers/User'
import { show } from '@/reducers/Modal'
import {Detail} from "@/views/MyProfile/Detail";
import { alert, info,success, error } from '@/reducers/Modal'
import { addUser, loadUser, unsetSelected } from '@/reducers/User'

class MyProfileController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null };
  }
  
    onSaveHandler = async (data) => {
        const { dispatch } = this.props;

     try {
        await dispatch(addUser(data)).then((retData) => {
            if(!retData.error) {
                //this.props.navigate("/team/", {"replace": true});
            }
        })
        if(!this.props.error) {
            dispatch( alert({"header": "Opslaan gegevens", "description": "De gegevens zijn met succes opgeslagen!"}) );
        }
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {

      }
        if(!this.props.error) {
            dispatch( success({"header": "Opslaan gegevens", "description": "De gegevens zijn met succes opgeslagen!"}) );
       } 

      
    }
  
  render() {
      return (
          <Detail {...this.props} key="profile" changekey={this.props.changeKey} onSaveHandler={this.onSaveHandler} interests={this.props.interests} experience={this.props.experience} userDocuments={this.props?.userDocuments}/>
      );
      
  }
}
const MyProfileControllerInit = (props) => {
  return (
    <MyProfileController 
      {...props} data={props.user}
    />
  );
};

function mapStateToProps(state) {
    const {AuthReducer, UserReducer, DocumentReducer} = state;
    const {interests, experience, user_interests, user_experience, key} = UserReducer;
    const {userDocuments} = DocumentReducer;
    const {user} = AuthReducer;
    const {error} = UserReducer;
    
  return {
    user: user,
    data: user,
    interests: interests,
    experience: experience,
    userDocuments: userDocuments,
    user_interests: user_interests,
    user_experience: user_experience,
    error: error,
    changeKey: key
  };
}

export default connect(mapStateToProps)(MyProfileControllerInit);  